import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { BaseDashboardInfoComponent } from './base-dashboard-info.component';
import { FormattingService } from '../../../../shared/services/formatting.service';

@Component({
  selector: 'sales-dashboard-info',
  template: `
    <span title="The total forecast in USD of all webshops in this list">{{forecast}}</span>
    <span title="The total number of open items in this list" [ngClass]="openItemsClass">{{openItems}}</span>
  `
})
export class SalesDashboardInfoComponent extends BaseDashboardInfoComponent implements OnChanges {
  public forecast:string;
  public openItems:string;
  public openItemsClass:string;

  constructor(
    private formattingService:FormattingService
  ) {
    super();
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.loading) {
      this.getCountsFromReportData();
    }
  }

  private getCountsFromReportData():void {
    const f:number = this.section?.report?.data?.aggregates?.sum?.Deforus;
    this.forecast = this.formattingService.formatAmount(f, 'USD');

    const o:number = this.section?.report?.data?.aggregates?.sum?.Deopeni;
    this.openItems = this.formattingService.formatNumber(o);
    if (this.openItems) {
      this.openItems += ' open item(s)';
    }

    this.openItemsClass = o? 'warn' : undefined;
  }
}